import { PrizeWall, PrizeWallPrize, ParsedPrizeWall } from './prizeWall.types';

const parsePrizeWallRewards = (rewards: PrizeWallPrize[]) =>
  rewards.reduce<ParsedPrizeWall['rewards']>(
    (accumulator, reward) => ({
      ids: [...accumulator.ids, reward.rewardId],
      byId: { ...accumulator.byId, [reward.rewardId]: reward },
    }),
    {
      ids: [],
      byId: {},
    },
  );

export const parsePrizeWall = ({
  rewards,
  ...rest
}: PrizeWall): ParsedPrizeWall => ({
  ...rest,
  rewards: parsePrizeWallRewards(rewards),
});
